module Meevo.Plugins.SmartCenter {
  "use strict";

  import SmartCenter = Meevo.Model.SmartCenter;

    /**
  * Main Section of Smart Center 
  */
  export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.SmartCenter> {

    constructor(
      sectionId: number,
      displayNameContentKey: string,
      template: string,
      isPrimarySection: boolean,
      handlesOwnCrud: boolean,
      baseEndpoint: string,
      sectionEndpoint: string,
      loggingService: Meevo.Components.Logging.ILoggingService,
      dataService: Meevo.Components.BaseClasses.IDataService,
      protected identityService: Meevo.Components.Common.IIdentityService = null,
      noun: Meevo.Model.NounEnum = null,
      appSettings?: Components.Common.IAppSettings,
      sectionSecurityKey?: string,
      protected modalService?: Meevo.Components.Modal.IModalService,
      protected tileCallback?: any,
      translate?: angular.translate.ITranslateService
    ) {
      super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService,
        dataService, identityService, noun, appSettings, sectionSecurityKey, translate);
    }

    public availabilityOption: string;


    get model() {
      return this._model;
    }

    set model(model: SmartCenter) {
        if (Model.Guard.isSomething(model)) {
            if (Model.Guard.isSomething(model.tiles)) {
                model.tiles = model.tiles.map(tile => new SmartCenterSmartTileModel(tile));
            }

            this._model = model;
            this.availabilityOption = this.model.isAvailableCo ? 'CO' : 'Locations';
        }  
    }

    private _model: SmartCenter;

    /**
  * Base class override which defines what a DEFAULT model looks like.
  */
    createSectionModelInstance(postAdd: (data: any) => any): void {
      this.dataService.getTemplate("smartCenter").then((data) => {
        this.model = data;
        if (Model.Guard.isSomething(this.model))
          this.availabilityOptionChanged();
      });
    }

    sectionModelRetrieved(): void {
      if (this.model) {
        this.model.tiles.forEach((tile: Model.SmartCenterSmartTile) => {
            if (tile.parameter) {
                tile.parsedParameters = JSON.parse(tile.parameter);
                if (!this.model.availableToLocations) {
                    if (Model.Guard.isSomething(tile.parsedParameters['locations']) && Model.Guard.isSomething(tile.parsedParameters['locations'].parameterValue)) {
                        tile.isForLocationGroup = false;
                    }
                    if (Model.Guard.isSomething(tile.parsedParameters['locationGroup']) && Model.Guard.isSomething(tile.parsedParameters['locationGroup'].parameterValue)) {
                        tile.isForLocationGroup = true;
                    }
                }
          }          
        });
        if (this.identityService.inCentralOfficeMode)
          this.availabilityOption = this.model.isAvailableCo ? 'CO' : 'Locations';
      }
    }

    public availabilityOptionChanged(): void {
        // When switching to CO availability and containing a tile not supported for CO smart centers, prompt and remove them
        var previewTiles = _.find(this.model.tiles, t => t.tileAvailabilityLevel == Model.TileAvailabilityLevelEnum.LocationOnly);
        // TODO: A future user story will add support for tiles not supported for individual locations (none of these exist yet).
        // Handle them here using the same pattern (just add another collection like "previewTiles" above and check them below)
        if (this.availabilityOption === 'CO' && Model.Guard.isSomething(previewTiles)) {
            //// Confirm whether user is ok with removing unsupported preview tiles
            const message = this.translateService.instant('MESSAGE_SMART_CENTER_REMOVE_TILE_WARNING');
            this.modalService.okCancelHandler(message)
                .then(result => {
                    if (!result) {
                        // Revert option
                        this.availabilityOption = 'Locations';
                        return;
                    } else {
                        this.model.tiles = _.reject(this.model.tiles, s => s.tileAvailabilityLevel == Model.TileAvailabilityLevelEnum.LocationOnly);
                        this.completeAvailabilityOptionChanged();
                    }
                });
        } else {
            this.completeAvailabilityOptionChanged();
        }
    }

    private completeAvailabilityOptionChanged(): void {
        this.model.isAvailableCo = this.identityService.inCentralOfficeMode ? this.availabilityOption === 'CO' : null;
        this.model.availableToLocations = this.identityService.inCentralOfficeMode ? this.availabilityOption === 'Locations' : null;
        this.tileCallback();
    }

    public showAvailabilityOptions(): boolean {
      return this.identityService.inCentralOfficeMode() ||
        (Model.Guard.isSomething(this.model) && this.identityService.checkCentralOfficeLocationId(this.model.homeLocationId));
    }

      preSave(): void {
          if (this.identityService.inCentralOfficeMode()) {
              if (this.identityService.userBusinessTypes.length == 1)
                  this.model.businessTypeDetail = this.identityService.userBusinessTypes[0];
          }
          super.preSave();
      }
  }

}
